<template>
  <header>
    <div class="logoSVE">
      <img class="logo" src="@/assets/LogoOriginalSVE.png" alt="Logo SVE">
      <span class="textoLogo">Sociedad Venezolana de Espeleología</span>
    </div>
    <div class="titulo">
      <h2 >Catálogo de la biblioteca</h2>
    </div>
    <div class="resto" v-if="!sesion">
      <div class="contLogoUser">
        <img class="logoUser" :src="icoUsuario" alt="Logo user">
        <span>{{usuarioEnSesion.nombre}}</span>
      </div>
      <div>
        <img class="icoSalir" src="@/assets/icoSalir.png" @click="closeSession">
      </div>
    </div>
  </header>
</template>

<script>
import icoUserSVE from '@/assets/IcoMiembroSVE.png'
import icoUserReg from '@/assets/icoUserReg.png'
import { mapState } from 'vuex'
export default {
  name: 'HeaderShowCol',
  created () {
    this.icoUsuario = this.usuarioEnSesion.tipoUsuario > 0 ? icoUserSVE : icoUserReg
  },
  data () {
    return {
      icoUsuario: ''
    }
  },
  methods: {
    closeSession () {
      this.$store.commit('doLogout')
      this.$router.push('/')
    }
  },
  computed: {
    ...mapState(['usuarioEnSesion']),
    sesion () {
      return (this.usuarioEnSesion.nombre === undefined)
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
header {
  /* display:flex; */
  /* justify-content: space-between; */
  height: 10vh;
  min-height: 70px;
  max-height: 90px;
  background-color: rgba(0, 90, 140, 0.65);
  /* width:90vw; */
  /* background-color: black; */
  display: grid;
  grid-template-columns: 22% 48% 30%;
  align-items:center;
  border:none;
}
.logoSVE{
  color:  rgb(250, 251, 251);
  display: grid;
  grid-template-columns: 30% 70%;
}
.logo{
  width: 45%;
  /* border: solid 1px orange; */
  justify-self:right;
  align-self: center;
  margin-right: 0.4rem;
}
.textoLogo{
  width: 90%;
  text-align:left ;
  font-family:ErasMD;
  padding-top: 0.15rem;
  font-size: 1.4vw;
  /* font-size: calc(0.82vw + 11px); */
  text-shadow: black 2px 2px 2px;
}
.titulo h2{
  /* color:  rgb(185, 227, 255); */
  color:  rgb(168, 168, 168);
  font-weight: 200;
  font-size: 30px;
  padding-left: 19%;

  /* border: solid 1px orange; */
}
/*.titulo h1{
  color:  rgb(185, 227, 255);
   border: none 1px orange;
}*/
.resto{
  color:  rgb(251, 251, 251);
  /* border: solid 1px orange; */
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.resto span{
 /* border: solid 1px orange; */
 margin-right: 25px;
}
.contLogoUser{
  display:flex;
  align-items: center;
}
.logoUser{
  /* border:  1px solid rgb(247, 222, 2); */
 /* display: inline-block; */
 /* position: relative; */
 /* width: 32px; */
 height: 32px;
 overflow: hidden;
 /* border-radius: 50%; */
 margin-right: 15px;
 justify-self: center;
 /* background-color: white; */
 /* margin-top: 10px; */
 /* margin-left: 15px; */
}
.icoSalir{
  height: 20px;
  cursor: pointer;
  margin-right: 25px;
  transition: all 0.5s ease-out;
}
.icoSalir:hover{
  transform: translateX(-5px);
}
/* header h1 {
  font-weight: lighter;
  font-size: 3vw;
  text-justify: auto ;
} */
@media screen and (max-width: 575px){
  header{
    width: 100vw;
    height: 8vh;
    min-height: 60px;
    grid-template-columns: 45% 55%;
  }
  .logo{
    width: 55%;
    justify-self: center;
    align-self: center;
    margin-left: 0.7rem;
    /* border:  1px solid rgb(247, 222, 2); */
  }
  .textoLogo{
    width: 100%;
    padding-top: 0.09rem;
    justify-self: left;
    font-size: 3.2vw;
    /* border:  1px solid rgb(247, 222, 2); */
  }
  .titulo{
    display: none;
  }
  .contLogoUser span{
   font-size: 14px;
  }
  .logoUser{
    /* width: 23px; */
    height: 23px;
    margin-right: 10px;
  }
  .icoSalir{
    /* background-color: rgba(208, 207, 207, 0.7); */
    content: url('@/assets/icoSalirB.png');
    padding: 3px;
    border-radius: 3px;
  }
}
@media screen and (max-width: 370px){
  header{
    width: 100vw;
    height: 8vh;
    min-height: 55px;
    grid-template-columns: 45% 55%;
  }
  .titulo{
    display: none;
  }
}
</style>
